

<ng-container>
    <div class="dcp-custom-form dcp p-2">
        <div class="d-flex align-items-center justify-content-between mb-3">
            <h2 class="mb-0">Referred status update</h2>
            <div class="btn-light btn-position" (click)="!isLoading && dialogRef.close()" [class.disabled]="isLoading">
                <span class="mat-icon material-icons">close</span>
            </div>
        </div>
        <div class="model-body">
            <form [formGroup]="form">
                <p>Are you referring the patient to OHI?</p>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group col-12">
                            <div class="custom-control custom-radio custom-radio-group-outer">
                                <input type="radio" id="11" class="custom-control-input" [value]="11"
                                    formControlName="status">
                                <label for="11" class="custom-control-label custom-radio-group">Yes</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group col-12">
                            <div class="custom-control custom-radio custom-radio-group-outer">
                                <input type="radio" id="0" class="custom-control-input" [value]="0"
                                    formControlName="status">
                                <label for="0" class="custom-control-label custom-radio-group">No</label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="d-flex justify-content-center align-items-center">
            <button class="btn btn-primary" (click)="formSubmit()" [disabled]="isLoading">{{isLoading ? 'Saving...' :
                'Save'}} </button>
        </div>
    </div>
</ng-container>